var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white",
    strokeOpacity: 0.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.45 19.4286C35.175 18.4286 34.4875 17.7143 33.525 17.4286C31.875 17 24.8625 17 24.8625 17C24.8625 17 17.9875 17 16.2 17.4286C15.2375 17.7143 14.55 18.4286 14.275 19.4286C14 21.2857 14 25 14 25C14 25 14 28.7143 14.4125 30.5714C14.6875 31.5714 15.375 32.2857 16.3375 32.5714C17.9875 33 25 33 25 33C25 33 31.875 33 33.6625 32.5714C34.625 32.2857 35.3125 31.5714 35.5875 30.5714C36 28.7143 36 25 36 25C36 25 36 21.2857 35.45 19.4286ZM22.8 28.4286V21.5714L28.575 25L22.8 28.4286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem2);
export default __webpack_public_path__ + "static/media/item (2).dded2ad85dbeddfb01874854d5a71f32.svg";
export { ForwardRef as ReactComponent };